
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"stroke-width":"1.6"}},[_c('path',{attrs:{"d":"M5 8.75h10.63M5 15.62h10.63M5 22.5h10.63"}})]),_c('g',{attrs:{"stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M19.38 8.58l2.04 2.05L25 6.53M19.38 15.46l2.04 2.04L25 13.41M19.38 22.33l2.04 2.05 3.58-4.1"}})])])])
          )
        }
      }
    